import { render } from "./BenefitsForm.vue?vue&type=template&id=ddb419c6"
import script from "./BenefitsForm.vue?vue&type=script&lang=js"
export * from "./BenefitsForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/giovanialves/Documents/projects/vue/web.vidalonga/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__